import routes from '@/modules/company/routes'
import store from '@/modules/company/store'

export default { routes, store }
